import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { LogoImage } from "@/components/ui/logo-image";

import { HStack } from "@/components/ui/h-stack";
import { Surface } from "@/components/ui/surface";
import { Text } from "@/components/ui/text";
import { VStack } from "@/components/ui/v-stack";
import { LanguageSelector } from "@/components/ui/language-selector";
import { ThemeToggle } from "@/components/ui/theme-toggle";
import { AuthRedirect } from "@/components/auth/auth-redirect";

function AuthLayout({ children }: { children: React.ReactNode }) {
  const { t: tAuth } = useTranslation("auth");
  const { t: tCommon } = useTranslation("common");

  return (
    <AuthRedirect>
      <VStack align="center" justify="center" className="min-h-screen p-4">
        {/* Language Selector - Top Right */}
        <HStack className="absolute top-4 right-4">
          <ThemeToggle />
          <LanguageSelector />
        </HStack>

        <VStack className="w-full max-w-md">
          {/* Logo */}
          <VStack className="text-center mb-8">
            <LogoImage width={270} height={105} className="mx-auto mb-3" />
            <Text color="muted" className="mt-2">
              {tAuth("logisticsPlatform")}
            </Text>
          </VStack>

          {/* Auth Card */}
          <Surface bg="container" rounded="2xl" className="shadow-xl p-8">
            {children}
          </Surface>

          {/* Footer */}
          <Text color="muted" className="mt-6" align="center">
            © {new Date().getFullYear()} Yuklar. {tCommon("allRightsReserved")}
          </Text>
        </VStack>
      </VStack>
    </AuthRedirect>
  );
}

export const Route = createFileRoute("/_auth")({
  component: function LayoutRoute() {
    return (
      <AuthLayout>
        <Outlet />
      </AuthLayout>
    );
  },
});
